var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.48 11.11L3.13 7.78L0 11.11L8.35 14.44L11.48 11.11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.52 11.11L15.65 14.44L24 11.11L20.87 7.78L12.52 11.11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.33L15.65 0L12.52 3.33L20.87 6.67L24 3.33Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.48 3.33L8.35 0L0 3.33L3.13 6.67L11.48 3.33Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 15.56C15.5105 15.5597 15.3726 15.5301 15.2451 15.4733C15.1177 15.4165 15.0035 15.3336 14.91 15.23L12 12.13L9.09002 15.23C8.99653 15.3336 8.88239 15.4165 8.75494 15.4733C8.6275 15.5301 8.48957 15.5597 8.35003 15.56C8.22272 15.5571 8.09714 15.53 7.98002 15.48L3.65002 13.76V16.67L12 20L20.35 16.67V13.76L16 15.48C15.8891 15.5276 15.7706 15.5547 15.65 15.56Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.84 10.07C11.8965 10.094 11.9501 10.1242 12 10.16C12.0498 10.1242 12.1035 10.094 12.16 10.07L19.29 7.22001L12.16 4.37001L12 4.29001L11.84 4.37001L4.70996 7.22001L11.84 10.07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.a2848f63545277563b4b2743a51bdfa0.svg";
export { ForwardRef as ReactComponent };